import { render } from "./AdminBusinesses.vue?vue&type=template&id=30bb3d68&scoped=true"
import script from "./AdminBusinesses.vue?vue&type=script&lang=js"
export * from "./AdminBusinesses.vue?vue&type=script&lang=js"

import "./AdminBusinesses.vue?vue&type=style&index=0&id=30bb3d68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bb3d68"]])

export default __exports__